import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '../auth/AuthProvider';
import { fetchMyTasks } from './queries';
import { setTaskCompleted } from '../tasks/queries';
import { taskKeys } from '../tasks/hooks';

export const myTaskKeys = {
  all: ['myTasks'] as const,
  list: (userId: string) => [...myTaskKeys.all, userId] as const,
};

export function useMyTasks() {
  const { client, access } = useAuth();
  const userId = access.status === 'approved' ? access.profile.id : '';
  return useQuery({
    queryKey: myTaskKeys.list(userId),
    queryFn: () => fetchMyTasks(client, userId),
    enabled: userId !== '',
    retry: false,
  });
}

/** Completes any of my tasks regardless of project (Home's Needs You Now). */
export function useCompleteMyTask() {
  const { client } = useAuth();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (args: { taskId: string; projectId: string | null }) =>
      setTaskCompleted(client, args.taskId, true),
    onSuccess: (_data, args) => {
      void queryClient.invalidateQueries({ queryKey: myTaskKeys.all });
      // A deal task has no project list to refresh; My Tasks covers it.
      if (args.projectId !== null) {
        void queryClient.invalidateQueries({ queryKey: taskKeys.project(args.projectId) });
      }
    },
  });
}
